module.exports = __webpack_public_path__ + "media/images/icon_new_blog-1e5d621bbf2a9a78d17e026bc912dd55.png";